/**
 * created by xcc
 * 图片预览组件
 */
import React, {Component} from 'react';
import {Icon} from "antd";
import {DetailDialog as Picture} from "../../../view/resource/view/dialog/picture/picture";

class PictureView extends Component {

    static defaultProps = {
        width: 120,
        height: 120,
    };

    constructor(props) {
        super(props);
        this.state = {
            previewPic: ""
        };
    }

    //鼠标移出
    handleOut = (item) => {
        item.hover = false;
        this.setState({})
    };

    //鼠标移入
    handleEnter = (item) => {
        item.hover = true;
        this.setState({})
    };

    render() {
        const {currentItem, width, height} = this.props;
        return (
            <>
                <img width={width} height={height} src={currentItem.url} alt={""}
                     onMouseEnter={() => this.handleEnter(currentItem)}/>
                {currentItem.hover ? this.renderBtn(currentItem, width, height) : null}
            </>
        )
    }

    renderBtn(currentItem, width, height) {
        return (
            <div style={{
                display: 'block'
            }} onMouseLeave={(e) => this.handleOut(currentItem)}>
                <div style={{
                    width: width,
                    height: height,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    padding: '0 10px'
                }}>
                    <Icon type={'eye'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              this.setState({
                                  previewPic: currentItem.url
                              }, () => {
                                  this.detailDialog.show();
                              })
                          }}
                    />
                </div>
                {/*预览*/}
                <Picture ref={ref => this.detailDialog = ref} path={this.state.previewPic}/>
            </div>
        )
    }
}

PictureView.propTypes = {};

export default PictureView;
